<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('add') }} {{ $t('binNumbers') }}</div>
      <div>
        <router-link class="btn-blue" to="bin-Numbers">{{ $t('binNumbers') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-md-4">
          <div class="dropdown-curve-container">
            <label
              :class=" selected.bank && selected.bank.length > 0 ? 'shift-up' : 'd-none' "
            >{{ $t('select') }} {{ $t('bank') }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <!-- <b-dropdown :text="selected.bank" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(bank,bankIndex) in banks"
                  :key="bankIndex"
                  @click="onSelectHandler('bank',bank)"
                  name="bank"
                  id="bank"
                >{{ bank.bank_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :options="banks"
                :searchable="true"
                :placeholder="selected.bank && selected.bank.length > 0 ? selected.bank: $tc('selectBank')"
                label="bank_name"
                track-by="bank_id"
                @select="onSelectHandler('bank',$event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
              <Tooltip :title="$t('selecktbankbinbumbers')" />
            </div>
            <p class="error_message">
              <span v-if="submitted && selected.bank.length == 0">{{$t('bankmsg')}}</span>
            </p>
          </div>
        </div>

        <div v-if="!showManual" class="col-md-4">
          <div class="d-flex justify-content-center align-items-center">
            <label for="file-selector3" class="file-selector w-100">
              <label
                class="file-selector-label"
                :class="binNumberFile.file_url && binNumberFile.file_url.length > 0 ? 'shift-up' : ''"
              >{{ $t('uploadbinnumbers') }}</label>
              <input
                v-on:change="uploadImage($event)"
                type="file"
                class="d-none"
                placeholder="."
                name="file-selector3"
                v-validate="'required'"
                id="file-selector3"
              />

              <span>{{binNumberFile.file_url}}</span>
            </label>

            <Tooltip :title="$t('uploadsheetbinnumbers')" />
          </div>
          <p class="error_message">
            <span
              v-if="submitted && binNumberFile.file_url.length == 0"
            >{{ $t('pleaseSelectBinNumberFile') }}.</span>
          </p>
        </div>

        <div v-if="showManual" class="col-md-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input placeholder="." type="text" name="card_type" id="card_type" v-model="CardType" />
              <label>{{ $t('cardtype') }}</label>
            </div>
            <Tooltip :title="$t('addcardtype')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && CardType.length == 0">{{ $t('pleaseEnterCardType') }}</span>
          </p>
        </div>

        <div v-if="showManual" v-for="(item, index) in BinInputs" :key="index" class="row">
          <div class="col-md-8">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  v-model="item.bin_number"
                  placeholder="."
                  type="text"
                  name="binNumber"
                  :id="'binNumber'+index"
                />
                <label>{{ $t('binNumbers') }}</label>
              </div>
              <Tooltip :title="$t('addbinNumber')" />
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('card_type')">{{ errors.first('card_type') }}</span>
            </p>
          </div>

          <div class="col-3 mb-4 pl-1">
            <button v-if="index == 0" @click.prevent.stop="addBinNumber()" class="btn-transparent">
              <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
            </button>
            <button v-else @click.prevent.stop="removeBinNumber(index)" class="btn-transparent">
              <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
            </button>
          </div>
        </div>

        <div class="col-md-4">
          <div class="row">
            <div class="">
              <label style="margin-bottom:0px;">{{ $t('addCardTypeManually') }}</label>
            </div>
            <div class="col-md-5 col-xl-15">
              <div class="col-4">
                <b-form-checkbox v-model="showManual" switch></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>
      </div>

      <table v-if="BinList && BinList.length > 0" class="list-view-table">
        <thead>
          <tr>
            <th>{{ $t('cardtype') }}</th>
            <th>{{ $t('binNumbers')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(binnumber, binnumberIndex) in BinList" :key="binnumberIndex">
            <td>
              <div class="j-checkbox">
                <b-form-checkbox v-model="binnumber.bin_is_active" unchecked-value="N" value="Y">
                  <div>{{binnumber.bin_card_type}}</div>
                </b-form-checkbox>
              </div>
            </td>
            <td>{{binnumber.bin_number}}</td>
          </tr>
        </tbody>
      </table>

      <div class="col-md-12 text-center mt-4">
        <button
          v-if="!showManual"
          :disabled="btenable"
          @click.prevent.stop="deleteUnselected()"
          class="btn-blue"
        >{{ $t('upload') }}</button>
        <button
          v-if="showManual"
          :disabled="btenable"
          @click.prevent.stop="onFinalSubmit(true)"
          class="btn-blue"
        >{{ $t('save') }}</button>
        <!-- <router-link class="btn-blue" to="bin-Numbers">{{ $t('cancel') }}</router-link> -->
        <b-button class="btn-outline-grey" variant="default" to="bin-Numbers">{{ $t('cancel') }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MarketingService from "@/services/MarketingService";

export default {
  data() {
    return {
      btenable: false,
      submitted: false,
      selected: {
        bank: "",
      },
      bank_id: "",
      binNumbers: [],
      BinList: [],
      binNumberFile: { file_url: "" },
      banks: [],
      result: [],
      showManual: false,
      BinInputs: [
        {
          bank_id: null,
          bin_card_type: "",
          bin_number: "",
        },
      ],
      CardType: "",
    };
  },

  beforeMount() {
    this.getBankList();
  },
  mounted() {},
  methods: {
    addBinNumber: function () {
      this.BinInputs.push({
        bank_id: null,
        bin_card_type: "",
        bin_number: "",
      });
    },
    removeBinNumber: function (index) {
      this.BinInputs.splice(index, 1);
    },
    uploadImage: function (file) {
      let self = this;
      let formData = new FormData();
      formData.append("file", file.target.files[0]);
      formData.append("filePath", "Bin Numbers File");
      MasterService.GlobalUploadFile(formData)
        .then((response) => {
          const { data } = response;
          data.message ? this.$toasted.show(data.message) : "";
          if (data.status) {
            self.binNumberFile.file_url = data.path;
          }
          self.getBinNumbers();
          self.BaseURL = data.BaseURL;
        })
        .catch((error) => {
          alert(
            "Sorry! Something went wrong. kindly contact your administrator"
          );
        });
    },
    getBankList: function () {
      // this.banks = [];
      let payload = {
        tableName: "ms_banks",
        bank_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          // console.log("data :", data);
          if (data.status && data.Records.length > 0) {
            this.banks = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getBinNumbers() {
      let payload = {
        file_url: this.binNumberFile.file_url,
      };
      MarketingService.getBinNumbers(payload).then((response) => {
        console.log("response :", response);
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            console.log("data.Records :", data.Records);
            this.BinList = data.Records;
            this.BinList.map((x) => {
              x["bin_is_active"] = "Y";
            });
          }
        }
      });
    },
    deleteUnselected: function () {
      this.result = this.BinList.filter((x) => {
        if (x.bin_is_active == "Y") {
          return x;
        }
      });
      this.onFinalSubmit(true);
    },
    onFinalSubmit: function (redirect) {
      this.submitted = true;
      let FinalArray = [];
      let flag;
      var reg = /^\d+$/;
      let countMatch = 0;
      let countLength = 0;

      if (!this.showManual) {
        flag = false;
        FinalArray = this.result.map((x) => {
          x["bank_id"] = this.bank_id;
          return x;
        });
      } else {
        flag = true;

        FinalArray = this.BinInputs.map((x, index) => {
          if (x.bin_number.length > 6 || x.bin_number.length < 6) {
            countLength++;
          } else {
            if (x.bin_number.length == 6 && x.bin_number.match(reg)) {
              x.bank_id = this.bank_id;
              x.bin_card_type = this.CardType;
            } else if (x.bin_number.match(reg) == null) {
              countMatch++;
            } else {
              this.BinInputs.splice(index, 1);
            }
          }
          return x;
        });
      }

      if (this.selected.bank.length == 0) {
        return;
      }
      if (!this.showManual && this.binNumberFile.file_url.length == 0) {
        return;
      }
      if (this.showManual && this.CardType.length == 0) {
        return;
      }
      if (countLength > 0) {
        return this.$toasted.show("Please enter 6 Digit Bin Numbers");
      }
      if (countMatch > 0) {
        this.$toasted.show(
          "Please enter only numbers OR remove unnecessary fields."
        );
        return;
      } else {
        let payload = {
          Details: FinalArray,
          Flag: flag,
        };
        this.btenable = true;
        let loader = this.$loading.show();

        MarketingService.addBinNumbers(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;
            // this.onResetForm();
            if (data.status) {
              this.$toasted.show(data.message);
              if (redirect) {
                // console.log("redirect value ", redirect);
                this.$router.push({
                  path: "/marketing/bin-Numbers",
                });
              }
            } else {
              this.btenable = false;
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      }
    },

    onSelectHandler: function (type, value) {
      if (type == "bank") {
        this.bank_id = value.bank_id;
        this.selected.bank = value.bank_name;
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/BinNumbersComponents/addBinNumbers.vue